export enum NewMarketFormEnum {
  FROM,
  TO,
  REGION,
}
